<template>
    <div>
      <v-layout row wrap justify-end align-end>
        <download-excel
          class="v-btn v-btn--floating v-btn--small theme--dark primary"
          :data="payments"
          :fields="fields"
          name="pagos.xls"
        >
          <v-icon color="white">cloud_download</v-icon>
        </download-excel>
      </v-layout>
        <v-card>
            <v-card-title>
                Reporte de pagos
                <v-spacer></v-spacer>
                <v-text-field
                    v-model="search"
                    append-icon="search"
                    label="Buscar"
                    single-line
                    hide-details
                ></v-text-field>
            </v-card-title>

            <v-data-table
                :headers="headers"
                :items="payments"
                :loading="loadingTable"
                class="elevation-1"
                :search="search"
            >
                <template slot="items" slot-scope="props">
                    <td class="text-xs-center">{{ props.item.created_at }}</td>
                    <td class="text-xs-center">{{ props.item.payment_type }}</td>
                    <td class="text-xs-center">{{ props.item.platform_app_name }}</td>
                    <td class="text-xs-center">{{ props.item.payment_id }}</td>
                    <td class="text-xs-center">{{ props.item.traceability_code }}</td>
                    <td class="text-xs-center">{{ props.item.updated_at }}</td>
                    <td class="text-xs-center">{{ $t(`enrollments.payment_status.${props.item.payment_state}`) }}</td>
                    <td class="text-xs-center">{{ props.item.payment_currency }} {{ formatNumber(props.item.service_payment_total || props.item.platform_payment_total) }}</td>
                    <td class="text-xs-center">{{ props.item.family_id }}</td>
                    <td class="text-xs-center">{{ props.item.student_number }}</td>
                    <td class="text-xs-center">{{ props.item.full_name }}</td>
                    <td class="text-xs-center">{{ props.item.student_grade_enrollment }}</td>
                </template>
                <v-alert slot="no-results" :value="true" color="error" icon="warning">
                    Your search for "{{ search }}" found no results.
                </v-alert>
            </v-data-table>
        </v-card>
    </div>
</template>

<script>
    import axios from 'axios'
    import JsonExcel from 'vue-json-excel'
    import { mapGetters } from 'vuex'

    export default {
        name: 'enrollments-reports-view',
        components: {
          'download-excel': JsonExcel,
        },
        data() {
            return {
                headers: [
                    { text: 'Fecha y hora creación', align: 'center', value: 'created_at' },
                    { text: 'Tipo pago', align: 'center', value: 'payment_type' },
                    { text: 'Aplicación', align: 'center', value: 'platform_app_name' },
                    { text: 'Referencia', align: 'center', value: 'payment_id' },
                    { text: 'Autorización/CUS', align: 'center', value: 'traceability_code' },
                    { text: 'Fecha y hora', align: 'center', value: 'updated_at' },
                    { text: 'Estado', align: 'center', value: 'payment_state' },
                    { text: 'Valor', align: 'center', value: 'total' },
                    { text: 'Código familia', align: 'center', value: 'family_id' },
                    { text: 'Código estudiante', align: 'center', value: 'student_number' },
                    { text: 'Nombre estudiante', align: 'center', value: 'full_name' },
                    { text: 'Grado estudiante', align: 'center', value: 'student_grade_enrollment' },
                ],
                payments: [],
                search: '',
                fields: {
                  'Fecha y hora creación': 'created_at',
                  'Tipo pago': 'payment_type',
                  'Aplicación': 'platform_app_name',
                  'Referencia': 'payment_id',
                  'Autorización/CUS': 'traceability_code',
                  'Fecha y hora': 'updated_at',
                  'Estado': 'payment_state',
                  'Valor': 'total',
                  'Código familia': 'family_id',
                  'Código estudiante': 'student_number',
                  'Nombre estudiante': 'full_name',
                  'Grado estudiante': 'student_grade_enrollment',
                }
            }
        },
        created() {
          this.getPayments()
        },
        methods: {
          async getPayments() {
              this.loadingTable = true;
              const { data } = await axios.get('/api/payment/reports')
              this.payments = data;
              this.loadingTable = false;
          },
          formatNumber(number) {
              if(typeof number === 'undefined'|| !number) {
                  return 0;
              } else {
                  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
              }
          }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/payment/reports.vue